import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { VERIFICATION_TICK_ICON, VERIFICATION_ERROR_ICON, BLUE_COG_SETTINGS_ICON } from '../../config/media';
import { Icon } from 'antd';

const ToDoList = ({ exchange = {}, handleApplyChanges, showApplyUpdate = true, type = '', user = {}, constant = {}, todoLoad = false }) => {
    const [showUpdate, setShowUpdate] = useState(false);
    let isCoinConfig = false;
    if (exchange.length) {
        isCoinConfig = !!(exchange.coins.filter(coin => !coin.id).length);
    }
    useEffect(() => {
        let splitKitVersion = constant && constant.kitVersion && constant.kitVersion.split`.`.map(x => +x);
        let splitExchangeVersion = (exchange && exchange.version && exchange.version.split`.`.map(x => +x)) || [];
        if (!splitExchangeVersion || !splitKitVersion) {
            setShowUpdate(false);
        } else if (splitKitVersion && splitExchangeVersion) {
            if (splitKitVersion[0] && splitExchangeVersion[0] && (splitKitVersion[0] > splitExchangeVersion[0])) {
                setShowUpdate(true);
            } else if (splitKitVersion[1] && splitExchangeVersion[1] && (splitKitVersion[1] > splitExchangeVersion[1])) {
                setShowUpdate(true);
            } else if ((splitKitVersion[2] || splitKitVersion[2] === 0) && splitExchangeVersion[2] && (splitKitVersion[2] > splitExchangeVersion[2])) {
                setShowUpdate(true);
            } else {
                setShowUpdate(false);
            }
        }
    }, [constant, exchange]);

    const handleAnimate = (ind = '') => {
        if (!exchange.domain && !exchange.url && !exchange.is_paid && !user.otp_enabled) {
            return `todoAnime${ind}`
        } else {
            return null
        }
    }

    return (
        <div>
            {(!exchange.domain || !exchange.url)
                ? <div className={handleAnimate()}>
                    {(exchange.domain && exchange.url) // ToDo: we need this condition in future. This is not affect current functionality.
                        ? <img src={VERIFICATION_TICK_ICON} className="requirement-icon" alt="status" />
                        : <Icon
                            type="minus-circle"
                            theme="filled"
                            style={{ fontSize: '12px', color: '#E87511' }}
                        />
                    }{' '}
                    <span>Connect your own domain</span>{' '}
                    <Link
                        to={
                            exchange.type === "Cloud"
                                ? "/hosting?tab=1"
                                : "/general"
                        }
                    >
                        (View)
                    </Link>
                </div>
                : null
            }
            {
                !exchange.region && exchange.type === "Cloud" ?
                    <div className={handleAnimate(1)}>
                        <Icon
                            type="minus-circle"
                            theme="filled"
                            style={{ fontSize: '12px', color: '#E87511' }}
                        />
                        {' '}
                        <span> Set server region</span>{' '}
                        <Link to="/hosting?tab=3">(View)</Link>
                    </div>
                    :
                    null
            }

            {exchange.type === "Cloud"
                ? (!exchange.is_paid
                    ? <div className={handleAnimate(2)} >
                        <Icon
                            type="minus-circle"
                            theme="filled"
                            style={{ fontSize: '12px', color: '#E87511' }}
                        />{' '}
                        <span>Pay pending bill</span>{' '}
                        <Link to="/billing">(View)</Link>
                    </div>
                    : <div className={handleAnimate(2)}>
                        <img
                            src={VERIFICATION_TICK_ICON}
                            className="requirement-icon"
                            alt="status"
                        />{' '}
                        <span>Pay pending bill</span>{' '}
                        <Link to="/billing">(View)</Link>
                    </div>
                )
                : (exchange.plan === 'boost'
                    ? null
                    : <div className={handleAnimate(2)}>
                        <Icon
                            type="minus-circle"
                            theme="filled"
                            style={{ fontSize: '12px', color: '#E87511' }}
                        />{' '}
                        <span>Upgrade your exchange to DIY Boost</span>{' '}
                        <Link to="/billing">(View)</Link>
                    </div>)
            }
            {showApplyUpdate && showUpdate
                ? <div className={handleAnimate(3)}>
                    <img src={VERIFICATION_ERROR_ICON} className="requirement-icon" alt="status" />{' '}
                    <span>Apply the latest update</span>{' '}
                    <Link to="/hosting">(View)</Link>
                </div>
                : null
            }
            {isCoinConfig
                ?
                <div/*  className='todoAnime4' */>
                    <img src={BLUE_COG_SETTINGS_ICON} className="requirement-icon" alt="status" />{' '}
                    <span>Configure your assets</span>{' '}
                    <Link to="/financial">(View)</Link>
                </div>
                : null
            }
            {exchange.type === "Cloud" && !exchange.is_running && type === "dashboard"
                ?
                <div className={handleAnimate(4)}>
                    <Icon
                        type="minus-circle"
                        theme="filled"
                        style={{ fontSize: '12px', color: '#E87511' }}
                    />
                    {' '}
                    <span>Go live</span>{' '}
                    <Link to="/hosting">(View)</Link>
                </div>
                : null
            }
            {type === "dashboard" ?
                <div className={handleAnimate(5)}>
                    {user.otp_enabled ?
                        <img src={VERIFICATION_TICK_ICON} className="requirement-icon" alt="status" />
                        :
                        <Icon className="warn-icon" type="exclamation-circle" theme="filled" />
                    }
                    {' '}
                    <span className={user.otp_enabled ? "" : "warn-icon"}>Turn on 2FA to secure your account</span>{' '}
                    <Link to="/mypage/modify-password">(View)</Link>
                </div>
                : null
            }
            {
                exchange.is_signed ?
                    <div className={handleAnimate(6)}>
                        <img
                            src={VERIFICATION_TICK_ICON}
                            className="requirement-icon"
                            alt="status"
                        />{' '}
                        {' '}
                        <span> Verified</span>{' '}
                    </div>
                    : <div className={handleAnimate(6)}>
                        <Icon className="warn-icon" type="exclamation-circle" theme="filled" />
                        <span className='pl-5 warn-icon'>Verification</span>{' '}
                        <Link to="/verifyAgree">(View)</Link>
                    </div>
            }

        </div>
    )
};

export default ToDoList;
